import React, { type FC } from 'react';

import { Inline, Stack, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';

const style = xcss({
	// Placeholder height value here, to try make the dialog be the height that it'll
	// end up as if it's replaced with the UI for unrestricted content.
	height: '144px',

	// However, it sounds like we want to do skeletons instead...
	// https://atlassian.slack.com/archives/C06MVDCR1FZ/p1718066765263229
});

export const LoadingBody: FC<{}> = () => (
	<Stack grow="fill" xcss={style}>
		<Inline grow="fill" alignInline="center" alignBlock="center">
			<Spinner interactionName="load" />
		</Inline>
	</Stack>
);
